import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <section className="section-x flex min-h-[70vh] items-center justify-center py-32">
      <div className="container-tmt text-center">
        <span className="font-display text-7xl font-semibold text-gradient sm:text-8xl">404</span>
        <h1 className="mt-4 font-display text-2xl font-semibold sm:text-3xl">This page took a vendor’s advice and got lost.</h1>
        <p className="mx-auto mt-3 max-w-md text-muted-foreground">Let’s get you back to solid, independent ground.</p>
        <Button variant="hero" size="lg" asChild className="mt-8">
          <Link to="/"><Home className="h-4 w-4" /> Back to Home <ArrowRight className="h-4 w-4" /></Link>
        </Button>
      </div>
    </section>
  );
}
